'use client';

import { useEffect } from 'react';
import goldCoinIcon from '@/assets/images/gold-coin.svg';
import { DMImage } from '@/components/custom-image/custom-image';
import { DMLink } from '@/components/link';
import { Sparkles } from '@/components/sparkle/Sparkle';
import useLoyaltyStore from '@/lib/zustand/store/loyaltyStore';

function UserCoin() {
  const { coin, fetchLoyalty } = useLoyaltyStore();
  useEffect(() => {
    fetchLoyalty();
  }, []);

  return (
    <DMLink
      href='/level-up'
      // className="bg-slate-800 rounded-xl p-2 flex items-center gap-1 h-10"
      className='flex items-center gap-1 hover:bg-slate-800 rounded-lg p-1'
    >
      <Sparkles>
        <DMImage src={goldCoinIcon} alt='Gold Coin Icon' width={20} height={20} />
      </Sparkles>
      <p className='text-white font-semibold'>{coin}</p>
    </DMLink>
  );
}

export default UserCoin;
